/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'download': {
    width: 16,
    height: 16,
    viewBox: '0 0 15.67 12.99',
    data: '<g data-name="图层 2"><g data-name="图层 1"><path pid="0" d="M7.83 6.61a.5.5 0 00.5-.5V.5a.5.5 0 10-1 0v5.61a.5.5 0 00.5.5zm7.33.89a.5.5 0 00-.5.5v4H1V8a.5.5 0 00-1 0v4.49a.5.5 0 00.5.5h14.67a.5.5 0 00.5-.5V8a.5.5 0 00-.5-.5z" _fill="#c4c4c4"/><path pid="1" _fill="#74777a" d="M7.83 9.9l4.06-5.06H3.77L7.83 9.9z"/></g></g>'
  }
})
